import ImageUpload from "../../../components/cms/ImageUpload";
import useSettings from "./useSettings";
import { SettingsHeader, Section, Field, Loading, MultiLangField } from "./_shared";

/**
 * SEO settings — <title>, <meta description> and OG image for all 4 languages,
 * plus the canonical base URL used to build hreflang alternate links.
 */
export default function SeoSettingsAdmin() {
  const { settings, set, save, saving, saved } = useSettings();
  if (!settings) return <Loading />;

  return (
    <div data-testid="cms-settings-seo">
      <SettingsHeader
        title="SEO y hreflang"
        description="Título y descripción de la página que se muestran en Google y redes sociales, por idioma. Al cambiar de idioma en el sitio público, se aplica automáticamente el par correspondiente."
        onSave={save}
        saving={saving}
        saved={saved}
      />

      <div className="space-y-6">
        <Section title="Título de la página (aparece en la pestaña del navegador y en Google)">
          <MultiLangField label="Título SEO" prefix="seo_title" settings={settings} set={set} />
        </Section>

        <Section title="Meta descripción (aparece bajo el título en los resultados de Google · 150-160 caracteres)">
          <MultiLangField label="Descripción SEO" prefix="seo_description" settings={settings} set={set} textarea rows={3} />
        </Section>

        <Section title="Imagen para compartir en redes (Open Graph / Twitter Card)">
          <p className="text-xs text-gray-500 mb-3">Recomendado: 1200×630 px, JPG o PNG. Se usa por defecto en todas las páginas si no hay una específica.</p>
          <ImageUpload
            label="Imagen OG por defecto"
            aspect="video"
            value={settings.seo_default_og_image ?? ""}
            onChange={(v) => set("seo_default_og_image", v)}
          />
        </Section>

        <Section title="URL canónica (para hreflang)">
          <p className="text-xs text-gray-500 mb-3">
            Se usa para construir los <code>&lt;link rel=&quot;alternate&quot; hreflang=&quot;…&quot;&gt;</code>. Déjelo vacío
            para que el sitio detecte automáticamente su URL. En producción, ingrese la URL definitiva
            (ej.: <code>https://www.cecit.es</code>).
          </p>
          <Field
            label="URL base"
            value={settings.seo_canonical_base}
            onChange={(v) => set("seo_canonical_base", v)}
          />
        </Section>
      </div>
    </div>
  );
}
